import { ModalEntryPhase, type ModalEntry } from './modal-stack-types';

export function findTopBackdropIndex(stack: ModalEntry[]): number {
  for (let index = stack.length - 1; index >= 0; index -= 1) {
    if (stack[index]?.backdrop) return index;
  }
  return -1;
}

export function countOpenEntries(stack: ModalEntry[]): number {
  return stack.reduce(
    (count, entry) => (entry.phase === ModalEntryPhase.Open ? count + 1 : count),
    0,
  );
}

export function getModalStackIds(stack: ModalEntry[]): string[] {
  return stack.map((entry) => entry.id);
}
